/**
 * The plan someone picked on the plans page before they had an account.
 *
 * Captured as an intent at the moment of the click (`/auth?mode=signup&plan=<key>`),
 * persisted here so it survives the Google/Microsoft redirect, then consumed exactly
 * once by onboarding — which confirms it instead of asking the plan question again.
 *
 * Plan keys only: the key is the immutable plan identity (labels and prices are editable).
 */
export const SIGNUP_PLAN_STORAGE_KEY = 'signupPlanKey';

export const readSignupPlanKey = (): string | null => {
  try {
    return localStorage.getItem(SIGNUP_PLAN_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const clearSignupPlanKey = (): void => {
  try {
    localStorage.removeItem(SIGNUP_PLAN_STORAGE_KEY);
  } catch {
    /* storage unavailable — nothing to clear */
  }
};
